// extracted by mini-css-extract-plugin
export default {"div__1":"Cart_div__1__zgBbD","div__2":"Cart_div__2__wUu0Z","div__3":"Cart_div__3__A37WF"};